module.exports = __webpack_public_path__ + "static/ui6-04771f22985997bca4e20ffb6646c4e3.mp3";